import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { AddCircle, Delete } from "@mui/icons-material";
import { Stack } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

const FlowBuilderButtonsModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [textDig, setTextDig] = useState("");
  const [arrayButtons, setArrayButtons] = useState([]);
  const [fallbackText, setFallbackText] = useState("");

  const [labels, setLabels] = useState({
    title: "Adicionar botões ao fluxo",
    btn: "Adicionar"
  });

  useEffect(() => {
    if (open === "edit") {
      setLabels({
        title: "Editar botões",
        btn: "Salvar"
      });
      setTextDig(data.data.message || "");
      setArrayButtons(data.data.arrayButtons || []);
      setFallbackText(data.data.fallbackMessage || "");
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: "Adicionar botões ao fluxo",
        btn: "Adicionar"
      });
      setTextDig("");
      setArrayButtons([]);
      setFallbackText("");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveButtons = async () => {
    if (!textDig || textDig.trim() === "") {
      toast.error("A mensagem de explicação dos botões não pode estar em branco!");
      return;
    }
    const emptyOption = arrayButtons.some(option => !option.value || option.value.trim() === "");
    if (emptyOption) {
      toast.error("Todos os botões devem estar preenchidos!");
      return;
    }

    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { message: textDig, arrayButtons, fallbackMessage: fallbackText }
      });
      return;
    } else if (open === "create") {
      handleClose();
      onSave({ message: textDig, arrayButtons, fallbackMessage: fallbackText });
    }
  };

  const removeOption = number => {
    setArrayButtons(old => old.filter(item => item.number !== number));
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">{labels.title}</DialogTitle>
        <Stack>
          <Stack dividers style={{ gap: "8px", padding: "16px" }}>
            <TextField
              label={"Mensagem de explicação dos botões"}
              rows={4}
              name="text"
              multiline
              variant="outlined"
              value={textDig}
              onChange={e => setTextDig(e.target.value)}
              className={classes.textField}
              style={{ width: "100%" }}
            />
            <div style={{ border: "2px solid orange", borderRadius: "8px", padding: "16px", marginTop: "16px" }}>
              <Typography variant="h6" style={{ color: "orange", marginBottom: "12px" }}>
                Configuração de Fallback
              </Typography>
              <TextField
                label={"Mensagem de fallback (ação inesperada)"}
                multiline
                rows={3}
                name="fallback"
                variant="outlined"
                value={fallbackText}
                onChange={e => setFallbackText(e.target.value)}
                className={classes.textField}
                style={{ width: "100%" }}
                placeholder={"Por favor selecione uma das opções para prosseguir."}
              />
            </div>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography>Adicionar Botão</Typography>
              <Button
                onClick={() =>
                  setArrayButtons(old => [
                    ...old,
                    { number: old.length + 1, value: "" }
                  ])
                }
                color="primary"
                variant="contained"
              >
                <AddCircle />
              </Button>
            </Stack>
            {arrayButtons.map((item, index) => (
              <Stack width={"100%"} key={item.number}>
                <Typography>Digite {item.number}</Typography>
                <Stack direction={"row"} width={"100%"} style={{ gap: "8px" }}>
                  <TextField
                    placeholder={"Digite texto do botão"}
                    variant="outlined"
                    value={item.value}
                    style={{ width: "100%" }}
                    onChange={event => {
                      const val = event.target.value;
                      setArrayButtons(old => {
                        const newArr = [...old];
                        newArr[index] = { ...newArr[index], value: val };
                        return newArr;
                      });
                    }}
                  />
                  {arrayButtons.length === item.number && (
                    <IconButton onClick={() => removeOption(item.number)}>
                      <Delete />
                    </IconButton>
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              Cancelar
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.btnWrapper}
              onClick={() => handleSaveButtons()}
            >
              {`${labels.btn}`}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderButtonsModal;
